(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-redux/assets/event-type-statistic-reducer.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-redux/assets/event-type-statistic-reducer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const _RTK = RTK,
  createReducer = _RTK.createReducer,
  isAnyOf = _RTK.isAnyOf;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.actions,
  fetchMatchInfo = _svs$components$sport.fetchMatchInfo,
  updateMatchOdds = _svs$components$sport.updateMatchOdds;
const _svs$components$sport2 = svs.components.sport.drawsRedux.actions,
  loadOpenedDrawsByEngine = _svs$components$sport2.loadOpenedDrawsByEngine,
  loadDrawByProduct = _svs$components$sport2.loadDrawByProduct,
  updateDraw = _svs$components$sport2.updateDraw;
const _svs$components$sport3 = svs.components.sportinfo.common.constants,
  EventTypeField = _svs$components$sport3.EventTypeField,
  EventTypeDistributionsFallback = _svs$components$sport3.EventTypeDistributionsFallback;
const _svs$components$sport4 = svs.components.sportinfo.common.helpers,
  createEventStatisticsKey = _svs$components$sport4.createEventStatisticsKey,
  normalizeEventTypeField = _svs$components$sport4.normalizeEventTypeField,
  normalizeOddsItem = _svs$components$sport4.normalizeOddsItem;
const normalizeDistributionItem = (distribution, eventTypeId) => distribution.reduce((acc, curr) => {
  if (!acc[curr.productId]) {
    acc[curr.productId] = {};
  }
  if (!acc[curr.productId][curr.drawNumber]) {
    acc[curr.productId][curr.drawNumber] = {};
  }
  acc[curr.productId] = _objectSpread(_objectSpread({}, acc[curr.productId]), {}, {
    [curr.drawNumber]: _objectSpread(_objectSpread({}, acc[curr.productId][curr.drawNumber]), normalizeOddsItem(curr.distribution, eventTypeId))
  });
  return acc;
}, []);
const eventTypeStatisticReducer = createReducer({}, builder => {
  builder.addCase(fetchMatchInfo.fulfilled, (state, action) => {
    const _action$meta$arg = action.meta.arg,
      matchId = _action$meta$arg.matchId,
      periodNumber = _action$meta$arg.periodNumber,
      eventNumber = _action$meta$arg.eventNumber;
    const _action$payload = _slicedToArray(action.payload, 2),
      odds = _action$payload[1];
    if (!odds.error) {
      const eventTypes = odds.eventTypes;
      eventTypes.forEach(_ref => {
        let eventTypeId = _ref.eventTypeId,
          odds = _ref.odds,
          startOdds = _ref.startOdds,
          favorite = _ref.favorite,
          distribution = _ref.distribution;
        const eventStatisticsKey = createEventStatisticsKey({
          matchId,
          eventTypeId,
          periodNumber,
          eventNumber
        });
        if (odds.length > 0) {
          const newOdds = normalizeEventTypeField(eventTypeId, EventTypeField.Odds, normalizeOddsItem(odds, eventTypeId));
          state[eventStatisticsKey] = _objectSpread(_objectSpread({}, state[eventStatisticsKey]), newOdds);
        }
        if (startOdds.length > 0) {
          const newOdds = normalizeEventTypeField(eventTypeId, EventTypeField.StartOdds, normalizeOddsItem(startOdds, eventTypeId));
          state[eventStatisticsKey] = _objectSpread(_objectSpread({}, state[eventStatisticsKey]), newOdds);
        }
        if (favorite.length > 0) {
          const newOdds = normalizeEventTypeField(eventTypeId, EventTypeField.Favourites, normalizeOddsItem(favorite, eventTypeId));
          state[eventStatisticsKey] = _objectSpread(_objectSpread({}, state[eventStatisticsKey]), newOdds);
        }
        if (distribution.length > 0) {
          var _state$eventStatistic;
          const normalizedDistribution = normalizeDistributionItem(distribution, eventTypeId);
          const newDistributionState = {
            [EventTypeField.Distributions]: _objectSpread({}, (state === null || state === void 0 || (_state$eventStatistic = state[eventStatisticsKey]) === null || _state$eventStatistic === void 0 ? void 0 : _state$eventStatistic[EventTypeField.Distributions]) || {})
          };
          const productIds = Object.keys(normalizedDistribution);
          productIds.forEach(productId => {
            var _state$eventStatistic2;
            const productIdState = ((_state$eventStatistic2 = state[eventStatisticsKey]) === null || _state$eventStatistic2 === void 0 || (_state$eventStatistic2 = _state$eventStatistic2[EventTypeField.Distributions]) === null || _state$eventStatistic2 === void 0 ? void 0 : _state$eventStatistic2[productId]) || {};
            const drawNumbers = Object.keys(normalizedDistribution[productId]);
            drawNumbers.forEach(drawNumber => {
              const parsedDraw = normalizeEventTypeField(eventTypeId, EventTypeField.Distributions, {
                [productId]: normalizedDistribution[productId][drawNumber]
              }, drawNumber);
              productIdState[drawNumber] = _objectSpread(_objectSpread({}, productIdState[drawNumber] || {}), parsedDraw[EventTypeField.Distributions][productId][drawNumber]);
              productIdState[EventTypeDistributionsFallback] = _objectSpread({}, parsedDraw[EventTypeField.Distributions][productId][drawNumber]);
            });
            newDistributionState[EventTypeField.Distributions][productId] = _objectSpread(_objectSpread({}, newDistributionState[EventTypeField.Distributions][productId]), productIdState);
          });
          state[eventStatisticsKey] = _objectSpread(_objectSpread({}, state[eventStatisticsKey]), newDistributionState);
        }
      });
    }
  }).addCase(updateMatchOdds, (state, action) => {
    const _action$payload2 = action.payload,
      matchId = _action$payload2.matchId,
      odds = _action$payload2.odds;
    const _ref2 = action.meta || {},
      periodNumber = _ref2.periodNumber,
      eventNumber = _ref2.eventNumber;
    if (!odds || odds.error) {
      return;
    }
    const eventTypes = odds.eventTypes;
    eventTypes.forEach(_ref3 => {
      let eventTypeId = _ref3.eventTypeId,
        odds = _ref3.odds;
      if (odds.length > 0) {
        const eventTypeStatId = createEventStatisticsKey({
          matchId,
          eventTypeId,
          periodNumber,
          eventNumber
        });
        const newOdds = normalizeEventTypeField(eventTypeId, EventTypeField.Odds, normalizeOddsItem(odds, eventTypeId));
        const _eventTypeStatId = state[eventTypeStatId] || {};
        const _eventTypeStatIdOdds = _eventTypeStatId[EventTypeField.Odds] || {};
        state[eventTypeStatId] = _objectSpread(_objectSpread(_objectSpread({}, _eventTypeStatId), newOdds), {}, {
          [EventTypeField.Odds]: _objectSpread(_objectSpread({}, _eventTypeStatIdOdds), newOdds[EventTypeField.Odds])
        });
      }
    });
  }).addCase(loadOpenedDrawsByEngine.fulfilled, (state, action) => {
    Object.assign(state, action.payload.EventTypeStatistic);
  }).addMatcher(isAnyOf(loadDrawByProduct.fulfilled, updateDraw), (state, action) => {
    const newEventTypeStatistics = action.payload.EventTypeStatistic || action.payload.draws.EventTypeStatistic || {};
    const eventStatisticsKeys = Object.keys(newEventTypeStatistics);
    eventStatisticsKeys.forEach(eventStatisticsKey => {
      if (!state[eventStatisticsKey]) {
        state[eventStatisticsKey] = newEventTypeStatistics[eventStatisticsKey];
      } else {
        for (const eventStatisticsType in newEventTypeStatistics[eventStatisticsKey]) {
          if (eventStatisticsType !== EventTypeField.Distributions) {
            state[eventStatisticsKey][eventStatisticsType] = newEventTypeStatistics[eventStatisticsKey][eventStatisticsType];
          }
        }

        const distributionKeys = newEventTypeStatistics[eventStatisticsKey].distributions ? Object.keys(newEventTypeStatistics[eventStatisticsKey].distributions) : [];
        distributionKeys.forEach(distributionKey => {
          if (state[eventStatisticsKey].distributions[distributionKey]) {
            state[eventStatisticsKey].distributions[distributionKey] = _objectSpread(_objectSpread({}, state[eventStatisticsKey].distributions[distributionKey]), newEventTypeStatistics[eventStatisticsKey].distributions[distributionKey]);
          } else {
            state[eventStatisticsKey].distributions[distributionKey] = newEventTypeStatistics[eventStatisticsKey].distributions[distributionKey];
          }
        });
      }
    });
  });
});
setGlobal('svs.components.sportinfo.matchInfoRedux.eventTypeStatisticReducer', eventTypeStatisticReducer);

 })(window);